import { generateRequest } from '.';

export const Action = {
  Amenities: {
    AmenitiesPending: 'Amenities_PENDING',
    AmenitiesCompleted: 'Amenities_FULFILLED',
    AmenitiesFailed: 'Amenities_FAILED',
  },
};

export const fetchAmenities = stationId => generateRequest({
  endpoint: `/assets-v2/api/stations/${stationId}/amenities`,
  types: [
    Action.Amenities.AmenitiesPending,
    Action.Amenities.AmenitiesCompleted,
    Action.Amenities.AmenitiesFailed,
  ],
});
